export default __webpack_public_path__ + "static/media/icon_cutthepaper.44287379.png";